/**
 * Supplier entity — warehouses.Supplier (xsite/warehouses/models.py, api.py SupplierSerializer).
 * Reference implementation of the model + resourceApi + resourceHooks pattern
 * (see src/shared/resourceApi.ts and src/shared/createResourceHooks.ts).
 */

import { createResourceApi } from '../shared/resourceApi';
import { createResourceHooks } from '../shared/createResourceHooks';

export interface Supplier {
  id: number;
  name: string;
  email: string;
  phone: string;
  notes: string;
}

export type SupplierInput = Pick<Supplier, 'name' | 'email' | 'phone' | 'notes'>;

export const supplierApi = createResourceApi<Supplier, SupplierInput, SupplierInput>(
  'warehouses/api/suppliers'
);

export const {
  keys: supplierKeys,
  useList: useSuppliers,
  useCreate: useCreateSupplier,
  useUpdate: useUpdateSupplier,
  useRemove: useDeleteSupplier,
} = createResourceHooks(supplierApi, {
  name: 'suppliers',
  model: 'warehouses.supplier',
});
